import React from "react";

const SOURCES = [
  { sport: "Soccer", type: "Established poll", by: "United Soccer Coaches" },
  { sport: "Lacrosse", type: "Established poll", by: "USA Lacrosse" },
  { sport: "Squash", type: "Established poll", by: "US Squash" },
  { sport: "Football", type: "Association ranking", by: "NHSSA committee" },
  { sport: "Basketball", type: "Association ranking", by: "NHSSA committee" },
  { sport: "Volleyball", type: "Association ranking", by: "NHSSA committee" },
];

const STEPS = [
  {
    step: "01",
    title: "Established polls where they exist",
    body: "For soccer, lacrosse and squash we publish the recognized national polls exactly as released, and show the poll name and date on every list.",
  },
  {
    step: "02",
    title: "Association ranking for the rest",
    body: "For football, basketball and volleyball the NHSSA committee compiles the rankings from full-season results, weighting opponent quality and margin.",
  },
  {
    step: "03",
    title: "Sourced and dated, always",
    body: "Every ranking shows its source and last-updated date, drawn straight from the official polls or the NHSSA committee—so you always know where a list comes from.",
  },
];

const Model = () => {
  return (
    <section id="model" className="py-16 sm:py-24 border-t border-[var(--line)]">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        {/* Source table */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-px rounded-3xl overflow-hidden border border-[var(--line)] bg-[var(--line)] mb-20">
          {SOURCES.map((s) => (
            <div key={s.sport} className="bg-[var(--paper)] px-6 py-6">
              <div className="text-lg font-extrabold text-[var(--ink)]">{s.sport}</div>
              <div className="mt-1 text-[11px] font-bold tracking-eyebrow uppercase text-[var(--olive-2)]">
                {s.type}
              </div>
              <div className="mt-1 text-[13px] text-[var(--muted)]">{s.by}</div>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-start">
          <div className="lg:sticky lg:top-28">
            <div className="flex items-center gap-4 mb-5">
              <span className="h-[2px] w-10 bg-[var(--olive)]" />
              <span className="text-xs font-bold tracking-eyebrow text-[var(--muted)] uppercase">
                How we rank
              </span>
            </div>
            <h2 className="text-4xl sm:text-6xl font-extrabold tracking-tight text-[var(--ink)] leading-[0.95]">
              One home, two{" "}
              <span className="font-serif-display italic font-medium text-[var(--olive-2)]">
                methods
              </span>
            </h2>
            <p className="mt-6 text-lg text-[var(--muted)] leading-relaxed max-w-md">
              Some sports have a trusted national poll—we publish it as-is. The
              rest are ranked by the association. Either way, the source and
              date are on every list so nothing is mistaken for official.
            </p>
          </div>

          <div className="space-y-4">
            {STEPS.map((m) => (
              <div
                key={m.step}
                className="group flex gap-6 rounded-3xl border border-[var(--line)] bg-[var(--paper)] p-7 transition-all hover:border-[var(--olive)]"
              >
                <span className="font-serif-display text-3xl font-semibold text-[var(--olive-2)] shrink-0">
                  {m.step}
                </span>
                <div>
                  <h3 className="text-xl font-extrabold text-[var(--ink)]">
                    {m.title}
                  </h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-[var(--muted)]">
                    {m.body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Model;
